import React from "react";
import aboutUsContent from "../new_redesign_components/content/AboutUs.json";
import Col3Cards from "../new_redesign_components/sections/Col3Cards";
import AboutUsBanner from "../new_redesign_components/sections/AboutUsBanner";
import Seo from "../common/Seo";
import { ORGANIZATION_JSON_LD, PAGE_SEO } from "../../constants/seo.mjs";
const About = () => {
  const { aboutUsBanner, col3Cards } = aboutUsContent;

  return (
    <>
      <Seo {...PAGE_SEO.about} jsonLd={[ORGANIZATION_JSON_LD]} />
      <AboutUsBanner content={aboutUsBanner} />
      <Col3Cards content={col3Cards} />
    </>
  );
};

export default About;
